'use client'

import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { ArrowUturnLeftIcon } from '@heroicons/react/24/solid'
import Logo from '~/components/Logo'
import { cn } from '~/utils/cn'

const Header = () => {
	const pathname = usePathname()
	const isHome = pathname === '/'

	return (
		<header className="grid grid-cols-3 w-full max-w-7xl mx-auto">
			<div>
				{!isHome ? (
					<Link href="/">
						<span className="flex shrink items-center space-x-3 h-full cursor-pointer w-fit group">
							<ArrowUturnLeftIcon className="w-8 h-8" />
							<span className="text-xl font-medium border-2 border-transparent group-hover:border-b-zephyr-light">
								Back
							</span>
						</span>
					</Link>
				) : null}
			</div>
			<div className="flex justify-center">
				<div className={cn('transition-[width] duration-200', isHome ? 'w-32' : 'w-16')}>
					<Link
						href="/"
						aria-label="Zephyr home"
					>
						<Logo className="fill-zephyr-blue" />
					</Link>
				</div>
			</div>
		</header>
	)
}

export default Header
